import * as React from 'react';
import { SliderItem, GetHandleProps, GetTrackProps } from 'react-compound-slider';

// *******************************************************
// HANDLE COMPONENT
// *******************************************************
interface IHandleProps {
	domain: number[];
	handle: SliderItem;
	getHandleProps: GetHandleProps;
}

export const Handle: React.FC<IHandleProps> = ({ domain: [min, max], handle: { id, value, percent }, getHandleProps }) => (
	<div
		role='slider'
		aria-valuemin={min}
		aria-valuemax={max}
		aria-valuenow={value}
		style={{
			left: `${percent}%`,
			position: 'absolute',
			marginLeft: '-5px',
			marginTop: '-5px',
			zIndex: 2,
			width: 10,
			height: 24,
			cursor: 'pointer',
			// borderRadius: '50%',
			// boxShadow: '1px 1px 1px 1px rgba(0, 0, 0, 0.2)',
			backgroundColor: 'rgb(212, 212, 212)',
		}}
		{...getHandleProps(id)}
	/>
);

// *******************************************************
// TRACK COMPONENT
// *******************************************************
interface ITrackProps {
	source: SliderItem;
	target: SliderItem;
	getTrackProps: GetTrackProps;
}

export const Track: React.FC<ITrackProps> = ({ source, target, getTrackProps }) => (
	<div
		style={{
			position: 'absolute',
			height: 14,
			zIndex: 1,
			backgroundColor: '#eae9e9',
			borderRadius: 7,
			cursor: 'pointer',
			left: `${source.percent}%`,
			width: `${target.percent - source.percent}%`,
		}}
		{...getTrackProps()}
	/>
);
// *******************************************************
// TICK COMPONENT
// *******************************************************
interface ITickProps {
	tick: any;
	count: number;
}

export const Tick: React.FC<ITickProps> = ({ tick, count }) => (
	<div>
		<div
			style={{
				position: 'absolute',
				marginTop: 14,
				width: 1,
				height: 5,
				backgroundColor: 'rgb(200,200,200)',
				left: `${tick.percent}%`,
			}}
		/>
		<div
			style={{
				position: 'absolute',
				marginTop: 22,
				fontSize: 10,
				textAlign: 'center',
				marginLeft: `${-(100 / count) / 2}%`,
				width: `${100 / count}%`,
				left: `${tick.percent}%`,
			}}
		>
			{tick.value}
		</div>
	</div>
);
